import geoViewport from '@mapbox/geo-viewport';
import FilterParamsManager from '../classes/filterParamsManager';
import {getCurrentLang} from '../helpers/helper';
import CoordsSession from '../helpers/coordsSession';
import Mapbox from '../classes/mapbox';

export default class FiltersMapbox extends FilterParamsManager {
    constructor () {
        super();
    }

    initElements() {
        if (document.getElementById('map')) {
            super.initElements(); // see FilterParamsManager@initElements

            // init map
            this.coords_session = new CoordsSession();
            let onMapLoad = (instance) => {
                instance.setMapCenter();
            };

            // if we came from Cities list page
            if (this.queryParams.get('b_lng')) {
                let b_lng = this.queryParams.get('b_lng'),
                    b_lat = this.queryParams.get('b_lat'),
                    t_lng = this.queryParams.get('t_lng'),
                    t_lat = this.queryParams.get('t_lat');

                this.params.set('b_lng', b_lng);
                this.params.set('b_lat', b_lat);
                this.params.set('t_lng', t_lng);
                this.params.set('t_lat', t_lat);

                this.queryParams.delete('b_lng');
                this.queryParams.delete('b_lat');
                this.queryParams.delete('t_lng');
                this.queryParams.delete('t_lat');
                history.replaceState(null, null, "?"+this.queryParams.toString());
                // to move to the viewport
                onMapLoad = (instance) => {
                    moveTo = geoViewport.viewport([
                        b_lng,
                        b_lat,
                        t_lng,
                        t_lat,
                    ], [instance.map.transform.width, instance.map.transform.height]);

                    if (moveTo) {
                        instance.inResultMove = true;

                        instance.map.easeTo(moveTo);
                        instance.map.once('idle', () => {
                            instance.inResultMove = false
                        });
                    } else {
                        instance.setMapCenter();
                    }
                }
            }
            this.setDefaultParams(false);
            this.map = new Mapbox(`/${getCurrentLang()}/fill-json?${this.params}`, this.coords_session.getCoordsFromSession(), 14, onMapLoad);
            this.map.init();
            this.map_container = document.querySelector('.map-container');
            this.resizeCallback = () => {};
        }
    }

    initEvents() {
        if (document.getElementById('map')) {
            this.mapToggle();
        }
    }

    /**
     * Toggle between Map+Event list view AND Only event list view
     */
    mapToggle() {
        let toggle_buttons= document.querySelectorAll('.map-toggle-btn');
        let select_sort= document.getElementById('select-sort');
        let select_loc= document.getElementById('select-loc');
        let wrap_container= document.querySelector('#search-wrap');
        let event_container= document.querySelector('.event-list');
        let event_cards= document.getElementsByClassName('event-card');
        let resetFiltersButton = document.getElementById('reset-filters-button');
        let event_wrapper = document.querySelector('#data-wrapper');
        let top_container = document.querySelector('.top-container');
        let body = document.querySelector("body");

        if (this.params.get('sort') === 'virtual') {
            this.map_container.classList.remove('open');
        }

        for(let button of toggle_buttons) {
            button.addEventListener('click', () => {
                resetFiltersButton.classList.toggle('active');

                if(this.map_container.classList.contains('open')) {
                    this.map_container.classList.remove('open');
                    select_sort.parentElement.classList.remove('hidden');
                    select_loc.parentElement.classList.remove('hidden');
                    event_container.classList.remove('smallEventWrapper');
                    body.classList.remove('no_scroll')
                    event_wrapper.classList.remove('hidden-on-phone');
                    wrap_container.style.maxWidth = '';
                    document.querySelectorAll('.display-list').forEach(function(element) {
                        element.classList.add('hidden');
                    });
                    document.querySelectorAll('.display-map').forEach(function(element) {
                        element.classList.remove('hidden');
                    });
                    if (!window.matchMedia("(max-width: 480px)").matches) {
                        wrap_container.classList.remove('small-wrap');
                        event_container.style.width = '100%';
                        event_container.style.position = 'inherit';

                        for(let card of event_cards) {
                            card.style.width = '';
                        }
                    } else {
                        wrap_container.style.maxWidth ='';
                        top_container.style.height = 'inherit';

                    }
                    this.params.delete('b_lng');
                    this.params.delete('b_lat');
                    this.params.delete('t_lng');
                    this.params.delete('t_lat');
                    this.params.delete('mode_map');
                    let event = new CustomEvent('map_closes', {
                        bubbles: true, // Allow the event to bubble up the DOM tree
                    });
                    // Dispatch the custom event on the document or the specific element
                    document.dispatchEvent(event);
                } else {
                    this.map_container.classList.add('open');
                    event_container.style.width = '';
                    select_sort.parentElement.classList.add('hidden');
                    select_loc.parentElement.classList.add('hidden');
                    document.querySelectorAll('.display-list').forEach(function(element) {
                        element.classList.remove('hidden');
                    });
                    document.querySelectorAll('.display-map').forEach(function(element) {
                        element.classList.add('hidden');
                    });

                    if (!window.matchMedia("(max-width: 480px)").matches) {
                        wrap_container.classList.add('small-wrap');
                        event_container.classList.add('smallEventWrapper');
                    } else {
                        event_wrapper.classList.add('hidden-on-phone');
                        wrap_container.style.maxWidth = '100%';
                        window.scroll(0,0)
                        body.classList.add('no_scroll');
                    }

                    this.map.map.resize();
                }
            });
        }

        const resizeObserver = new ResizeObserver(e => {
            if(!window.matchMedia("(max-width: 480px)").matches && this.map_container.classList.contains('open')) {
                wrap_container.classList.add('small-wrap');
                event_container.classList.add('smallEventWrapper');
                event_wrapper.classList.remove('hidden-on-phone');
                wrap_container.style.maxWidth = '';
                body.classList.remove('no_scroll');
            }
        });
        resizeObserver.observe(body);
    }
}
